module.exports = __webpack_public_path__ + "img/takuvuq-full-texture.d51c8ee5.png";